import { defineMessages } from "react-intl";
const messages = defineMessages({
    title: {
        id: "app.aiDiscoverability.mobileGate.title",
        defaultMessage: "View this report on desktop",
    },
    description: {
        id: "app.aiDiscoverability.mobileGate.description",
        defaultMessage: "Discover is a data-rich dashboard meant to be viewed on a bigger screen.",
    },
    continueAnyway: {
        id: "app.aiDiscoverability.mobileGate.continueAnyway",
        defaultMessage: "Continue anyway",
    },
});
export default messages;
